import { render, staticRenderFns } from "./Nobu1.vue?vue&type=template&id=468f124f&scoped=true"
import script from "./Nobu1.vue?vue&type=script&lang=js"
export * from "./Nobu1.vue?vue&type=script&lang=js"
import style0 from "./Nobu1.vue?vue&type=style&index=0&id=468f124f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f124f",
  null
  
)

export default component.exports